import { useState } from "react";
import { AlertCircle, Loader2, UserPlus } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { api, errorMessage } from "../../lib/api";
import { ROLE_LABELS } from "../../context/AuthContext";

const EMPTY = { name: "", email: "", password: "", role: "equipo" };
export const MSG_PASSWORD = "La contraseña debe tener al menos 8 caracteres";

export const NewUserDialog = ({ onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.password.length < 8) return setError(MSG_PASSWORD);
    setSaving(true);
    setError("");
    try {
      const { data } = await api.post("/users", form);
      onCreated(data);
      setForm(EMPTY);
      setOpen(false);
    } catch (err) {
      setError(errorMessage(err, "No se pudo crear el usuario, intenta de nuevo"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); setError(""); }}>
      <button type="button" onClick={() => setOpen(true)} className="tr-btn-primary px-4 py-2.5 text-sm" data-testid="new-user-button">
        <UserPlus className="h-4 w-4" /> Nuevo usuario
      </button>
      <DialogContent className="max-w-md" data-testid="new-user-dialog">
        <DialogHeader className="text-left">
          <DialogTitle className="text-lg font-extrabold text-[#182235]">Nuevo usuario</DialogTitle>
          <DialogDescription className="text-xs text-[#5b667a]">El usuario podrá entrar con este correo y la contraseña inicial.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3.5" data-testid="new-user-form">
          <label className="block"><span className="tr-label">Nombre</span><input required value={form.name} onChange={set("name")} className="tr-input" data-testid="new-user-name" /></label>
          <label className="block"><span className="tr-label">Correo electrónico</span><input required type="email" value={form.email} onChange={set("email")} className="tr-input" data-testid="new-user-email" /></label>
          <label className="block"><span className="tr-label">Contraseña inicial (mínimo 8 caracteres)</span><input required type="text" autoComplete="off" value={form.password} onChange={set("password")} className="tr-input" data-testid="new-user-password" /></label>
          <label className="block">
            <span className="tr-label">Rol</span>
            <select value={form.role} onChange={set("role")} className="tr-input" data-testid="new-user-role">
              {Object.entries(ROLE_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </label>
          {error && (
            <p role="alert" className="flex items-center gap-2 rounded-[10px] bg-[#fdf0ef] px-3 py-2 text-xs font-semibold text-[#b42318]" data-testid="new-user-error">
              <AlertCircle className="h-4 w-4 shrink-0" /> {error}
            </p>
          )}
          <button type="submit" disabled={saving} className="tr-btn-primary h-11 w-full text-sm" data-testid="new-user-submit">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Crear usuario"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
